import { useQuery } from '@tanstack/react-query';
import { integrationHubApi } from '../api/integrationHubApi';

/**
 * GET /api/eraf/integration-hub/call-logs/{id} — 호출 이력 상세 (INTEGRATION_READ)
 * queryKey: ['integration-hub', 'call-logs', 'detail', id]
 */
export function useCallLog(id: number | null) {
  return useQuery({
    queryKey: ['integration-hub', 'call-logs', 'detail', id],
    queryFn: () => integrationHubApi.getCallLog(id!),
    enabled: id !== null,
    staleTime: 60_000,
  });
}
